import { useSelector, useDispatch } from 'react-redux';
import {
  projectPickerSelectors,
  projectPickerActions,
} from '../redux/modules/projectPicker';
import { Project } from '../common/types/Projects';

export const useActiveProject = (): [Project, Function] => {
  const dispatch = useDispatch();
  const activeProject = useSelector(projectPickerSelectors.selectActiveProject);
  const setActiveProject = async (newActiveProject: Project) =>
    await dispatch(projectPickerActions.setActiveProject(newActiveProject.id));

  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  return [activeProject, setActiveProject];
};

export default useActiveProject;
